<template>
  <div class="Tenants">
    <b-row class="mb-4 align-items-end">
      <b-col class="text-left">
        <h1>Résidences</h1>
      </b-col>

      <b-col cols="2" class="text-right"
        ><b-button class="" variant="outline-primary" @click="createAsset">
          <i class="fa fa-plus" />
          Créer une nouvelle résidence</b-button
        ></b-col
      >
    </b-row>
    <TableView
      id="tableView"
      ref="tableView"
      controller="device-manager/asset"
      collection="assets"
      dataType="asset"
      add-item-label="Add an asset"
      :hide-edit-action="true"
      :hide-create-action="true"
      :index="currentTenantIndex"
      :show-on-map-action="true"
      @show-on-map="showOnMap"
      @fetched="fetched"
    >
    </TableView>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import get from 'lodash/get';
import { mapGetters } from 'vuex';
import TableView from '@/components/residencies/TableView';

export default {
  components: {
    TableView,
  },
  computed: {
    ...mapGetters('tenants', ['selectedTenant']),
    currentTenantIndex() {
      return get(this.selectedTenant, 'index', '');
    },
  },
  setup() {
    const markers = ref([]);
    const map = ref(null);
    const assetList = ref(null);

    return {
      markers,
      map,
      assetList,
      fetched: (items) => {
        markers.value = [];
        for (const item of items) {
          if (get(item, 'measures.position.point', false)) {
            markers.value.push({
              _id: item._id,
              coords: {
                lat: item.measures.position.point.lat,
                lng: item.measures.position.point.lon,
              },
              popupData: {
                model: item.model,
                reference: item.reference,
                type: item.type,
              },
            });
          }
        }
      },
      invalidateSize: () => {
        map.value.invalidateSize();
      },
      boundsUpdated: (val) => {
        assetList.value.fetchItems(val);
      },
      showOnMap: (pos) => {
        if (!pos) {
          this.$log.warn(
            'Unable to locate item on the map: position is undefined'
          );
          return;
        }
        map.value.map.mapObject.setView(new L.LatLng(pos.lat, pos.lon), 13);
      },
      createAsset() {
        this.$refs.tableView.createResidence();
      },
    };
  },
};
</script>

<style lang="scss">
#assetList .overflow-auto {
  max-height: 65vh;
  overflow: auto;
}
</style>
